<template>
    <QuestionBaseQuiz :question="question">
        <div>
            <div>
                <draggable
                    tag="div"
                    v-model="start"
                    group="elements"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                    handle=".handle"
                    class="list-group"
                    item-key="id"
                >
                    <template #item="{ element }">
                        <div class="flex flex-col p-4 bg-gray-50 mt-3 border-2 list-group-item">
                            <div class="flex items-center">
                                <div class="inline-block">
                                    <IconGripVertical
                                        class="handle inline-block h-8 w-8 text-indigo-600 cursor-move pr-1"
                                    />
                                </div>
                                <div>
                                    <span>
                                        <LatexMaybe :model-value="element.text" :is-latex="question.is_latex_answers" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>

            <div class="mt-3">
                <div class="border-dashed border-2 border-sky-500 p-2">
                    <div class="flex items-center gap-2 text-gray-700 text-sm">
                        <div>
                            <IconHelpCircle
                                class="h-6 w-6 text-gray-400 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                            />
                        </div>
                        <div>
                            <div v-if="status === 'empty'">
                                {{ $t('messages.order_elements_explanation_empty_state') }}
                            </div>
                            <div v-if="status === 'full'">
                                {{ $t('messages.order_elements_explanation_full_state') }}
                            </div>
                            <div v-if="status === 'partial'">
                                {{
                                    $t('messages.order_elements_explanation_partial_state', {
                                        count: start.length,
                                    })
                                }}
                            </div>
                        </div>
                    </div>
                    <draggable
                        tag="div"
                        v-model="elements"
                        group="elements"
                        v-bind="dragOptions"
                        @start="drag = true"
                        @end="drag = false"
                        handle=".handle"
                        @change="reorderPieces()"
                        class="list-group flex flex-col gap-2 mt-2"
                        item-key="id"
                        style="min-height: 80px"
                    >
                        <template #item="{ element }">
                            <div class="flex flex-col p-4 bg-gray-50 border-2 list-group-item">
                                <div class="flex items-center">
                                    <div class="inline-block">
                                        <IconGripVertical
                                            class="handle inline-block h-8 w-8 text-indigo-600 cursor-move pr-1"
                                        />
                                    </div>
                                    <div>
                                        <span>
                                            <LatexMaybe
                                                :model-value="element.text"
                                                :is-latex="question.is_latex_answers"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>

            <div class="mt-3 bg-blue-200 hidden">
                {{ answer }}
            </div>

            <div class="mt-1">
                <button @click="reset" :class="{ invisible: isEmpty }" class="text-gray-600" type="button">
                    <IconX class="w-6 h-6 inline-block" />
                    {{ $t('messages.delete_answer') }}
                </button>
            </div>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
import draggable from 'vuedraggable';
import { IconGripVertical, IconHelpCircle, IconX } from '@tabler/icons-vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';
import LatexMaybe from '../LatexMaybe.vue';

export default {
    emits: ['update:modelValue'],
    name: 'QuestionOrderElementsQuiz',
    components: {
        IconHelpCircle,
        IconX,
        LatexMaybe,
        QuestionBaseQuiz,
        draggable,
        IconGripVertical,
    },
    props: {
        question: {
            required: true,
        },
        modelValue: {
            required: true,
        },
    },
    data() {
        return {
            answer: this.modelValue,
            start: this.question.options.elements,
            elements: [],
            drag: false,
        };
    },
    methods: {
        reorderPieces() {
            const ids = this.elements.map((p) => p.id);
            this.answer = JSON.stringify(ids);
        },
        reset() {
            this.answer = null;
            this.elements = [];
            this.start = this.question.options.elements;
        },
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: 'elements',
                disabled: false,
                ghostClass: 'ghost',
            };
        },
        status() {
            if (this.isEmpty) {
                return 'empty';
            }
            if (this.elements.length === this.question.options.elements.length) {
                return 'full';
            }

            return 'partial';
        },
        isEmpty() {
            return this.answer === '' || this.answer === null;
        },
    },
    watch: {
        answer(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
<style scoped>
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.2;
    background-color: #c7d2fe;
}
.list-group {
    min-height: 20px;
}
</style>
